<!--
 * @Descripttion: 接口设置
 * @Author: zenghua.wang
 * @Date: 2021-06-07 14:08:44
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-03-30 14:30:09
-->
<template>
  <el-collapse-item :title="title">
    <el-form-item
      label="apis"
      v-if="apis"
    >
      <el-row>
        <el-col :span="main.microOpen==='true' ? 24 : 14">
          <el-select
            v-model="data.apiId"
            clearable
            filterable
            placeholder="请选择"
            @change="onChange"
          >
            <el-option
              v-for="item in apis"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col
          :span="10"
          v-if="main.microOpen!=='true'"
        >
          <el-button
            type="primary"
            style="margin-left: 10px"
            @click="goToApi"
          >{{ data.apiId ? "去设置" : "去新增" }}</el-button>
        </el-col>
      </el-row>
    </el-form-item>

    <!-- <el-form-item label="启用apis">
      <el-switch
        v-model="data.option.request"
        :active-color="theme.active"
        :inactive-color="theme.inactive"
      />
    </el-form-item> -->

    <!-- v-slot:extend -->
    <slot name="extend"></slot>

    <el-form-item
      label="刷新时间(ms)"
      v-if="category === 'screen'"
    >
      <el-input-number
        v-model="data.option.refreshTime"
        clearable
        placeholder="请输入"
      >
      </el-input-number>
    </el-form-item>

    <el-button
      v-if="refreshBtn"
      type="primary"
      style="width: 100%"
      :disabled="data.option.refresh"
      @click="setRefresh"
    >刷新数据
    </el-button>
  </el-collapse-item>
</template>

<script>
import { theme, component } from '@/dragComponents/model/default.js'
import { isEmpty } from '@/dragComponents/utils'

export default {
  name: 'api-interface',
  components: {},
  inject: ['main', 'category'],
  props: {
    title: {
      type: String,
      default: '接口设置'
    },
    refreshBtn: {
      type: Boolean,
      default: true
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    apis: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      theme: theme,
      component: component,
      options: {
        sizeList: ['medium', 'small', 'mini']
      },
      loading: false,
      disabled: false
    }
  },
  watch: {
    'data.apiId'(val) {
      if (!val) this.main.apiFieldList = []
    }
  },
  methods: {
    goToApi() {
      this.$router.push({
        path: '/apisManage/index'
      })
    },
    onChange(id) {
      if (!id) return
      this.loading = true
      this.data.apiId = id
      this.$http
        .get(`/apis/main-config/${id}`)
        .then((res) => {
          if (res.code === 200) {
            if (isEmpty(res.data.apisMainOutCtlsModels)) {
              this.$message.error('apis接口输出配置配置出错了，快去查看配置！')
            }
            const list = res.data.apisMainOutCtlsModels.apisMainOutCtlsDataList
            let temp = []
            if (list.length > 0) {
              list.map((item, index) => {
                temp.push({
                  label: item.outPutPath,
                  value: item.outPutPath,
                  disabled: false
                })
              })
            }
            this.main.apiFieldList = temp
            this.data.option.reqMethod = res.data.apisMainConfig.reqMethod
            this.loading = false
          }
        })
        .catch((err) => {
          this.loading = false
          this.$message.error(err.msg)
        })
    },
    setRefresh() {
      if (!this.data.apiId) return
      this.data.option.refresh = true
    }
  }
}
</script>
